var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.00146H1C0.716667 8.00146 0.479167 7.90563 0.2875 7.71396C0.0958333 7.5223 0 7.2848 0 7.00146C0 6.71813 0.0958333 6.48063 0.2875 6.28896C0.479167 6.0973 0.716667 6.00146 1 6.00146H6V1.00146C6 0.718132 6.09583 0.480632 6.2875 0.288965C6.47917 0.0972982 6.71667 0.00146484 7 0.00146484C7.28333 0.00146484 7.52083 0.0972982 7.7125 0.288965C7.90417 0.480632 8 0.718132 8 1.00146V6.00146H13C13.2833 6.00146 13.5208 6.0973 13.7125 6.28896C13.9042 6.48063 14 6.71813 14 7.00146C14 7.2848 13.9042 7.5223 13.7125 7.71396C13.5208 7.90563 13.2833 8.00146 13 8.00146H8V13.0015C8 13.2848 7.90417 13.5223 7.7125 13.714C7.52083 13.9056 7.28333 14.0015 7 14.0015C6.71667 14.0015 6.47917 13.9056 6.2875 13.714C6.09583 13.5223 6 13.2848 6 13.0015V8.00146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLogo);
export default __webpack_public_path__ + "static/media/Add_Logo.8759cb2a35382c495b1f5b8fe142d535.svg";
export { ForwardRef as ReactComponent };